import { useState, useEffect } from 'react';
import { garcomService } from '../../services';

export default function Garcons() {
  const [garcons, setGarcons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome: '', username: '', password: '', telefone: '' });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => {
    garcomService.listar()
      .then(res => setGarcons(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => {
    setEditando(null);
    setForm({ nome: '', username: '', password: '', telefone: '' });
    setErro('');
    setModal(true);
  };

  const abrirEditar = (g) => {
    setEditando(g);
    setForm({ nome: g.nome, username: g.username, password: '', telefone: g.telefone || '' });
    setErro('');
    setModal(true);
  };

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    setSalvando(true);
    try {
      if (editando) {
        const payload = { nome: form.nome, telefone: form.telefone };
        if (form.password) payload.password = form.password;
        await garcomService.atualizar(editando.id, payload);
      } else {
        await garcomService.criar(form);
      }
      setModal(false);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  const toggleAtivo = async (g) => {
    try {
      await garcomService.atualizar(g.id, { ativo: g.ativo ? 0 : 1 });
      carregar();
    } catch {}
  };

  if (loading) return <div className="loading"><div className="spinner"></div>Carregando...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1>🧑‍🍳 Garçons</h1>
        <button className="btn btn-primary" onClick={abrirNovo}>+ Novo Garçom</button>
      </div>

      <div className="table-container card">
        <table>
          <thead>
            <tr><th>Nome</th><th>Usuário</th><th>Telefone</th><th>Status</th><th>Último Acesso</th><th>Ações</th></tr>
          </thead>
          <tbody>
            {garcons.map(g => (
              <tr key={g.id}>
                <td><strong>{g.nome}</strong></td>
                <td><code>{g.username}</code></td>
                <td>{g.telefone || '-'}</td>
                <td>
                  <span className={`badge ${g.ativo ? 'badge-success' : 'badge-danger'}`}>
                    {g.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td>{g.ultimo_acesso ? new Date(g.ultimo_acesso).toLocaleString('pt-BR') : 'Nunca'}</td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-sm btn-info" onClick={() => abrirEditar(g)}>Editar</button>
                  <button
                    className={`btn btn-sm ${g.ativo ? 'btn-warning' : 'btn-success'}`}
                    onClick={() => toggleAtivo(g)}
                  >
                    {g.ativo ? 'Desativar' : 'Ativar'}
                  </button>
                </td>
              </tr>
            ))}
            {garcons.length === 0 && (
              <tr><td colSpan="6" className="no-data">Nenhum garçom cadastrado</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>{editando ? 'Editar Garçom' : 'Novo Garçom'}</h2>
            <form onSubmit={salvar}>
              {erro && <div className="alert alert-danger">{erro}</div>}
              <div className="form-group">
                <label>Nome *</label>
                <input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required />
              </div>
              {!editando && (
                <div className="form-group">
                  <label>Usuário *</label>
                  <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required />
                </div>
              )}
              <div className="form-group">
                <label>{editando ? 'Nova Senha (deixe em branco para manter)' : 'Senha *'}</label>
                <input
                  type="password"
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  required={!editando}
                />
              </div>
              <div className="form-group">
                <label>Telefone</label>
                <input value={form.telefone} onChange={e => setForm({ ...form, telefone: e.target.value })} />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                <button type="button" className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={salvando}>
                  {salvando ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
